export const NEW = {
  value: "new",
  key: "clients.client.premiumSimulator.form.employeeTypes.new",
};
export const EXISTING = {
  value: "existing",
  key: "clients.client.premiumSimulator.form.employeeTypes.existing",
};

export default [NEW, EXISTING];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/employeeTypeChoices.js